import { render, staticRenderFns } from "./DraftLanding.vue?vue&type=template&id=73faa06d&"
import script from "./DraftLanding.vue?vue&type=script&lang=js&"
export * from "./DraftLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports